import { Link } from 'react-router-dom';
import MovieCard from '@/components/feature/MovieCard';
import { newReleases } from '@/mocks/movies';

export default function NewReleaseSection() {
  return (
    <section className="w-full px-4 md:px-8 py-10 md:py-14 bg-white">
      <div className="max-w-screen-2xl mx-auto">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-serif">
              <i className="ri-sparkling-line text-primary-500 mr-2"></i>
              最新上线
            </h2>
            <p className="text-sm text-foreground-500 mt-1">新鲜出炉的热门影视，第一时间更新</p>
          </div>
          <Link
            to="/category/all"
            className="hidden sm:flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6 gap-4 md:gap-5" data-product-shop="">
          {newReleases.map((movie) => (
            <MovieCard key={movie.id} movie={movie} size="normal" />
          ))}
        </div>

        <Link
          to="/category/all"
          className="sm:hidden flex items-center justify-center gap-1 mt-4 text-sm text-primary-500 hover:text-primary-600 transition-colors cursor-pointer"
        >
          查看全部最新资源
          <i className="ri-arrow-right-line"></i>
        </Link>
      </div>
    </section>
  );
}